import { yii } from './yii';

export const CONFIG = {
    hasOffer: true,
    hasList: true,
    searchMap: {
        active: false,
        placeholder: yii.searchMapPlaceholder
    }
};

export const LOADERS = {
    getQuotation: false,
    searchHotels: false
};
